import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import InfoIcon from '../Icons/InfoIcon';

import useStyles from './makeStyles';
import { aliceGray } from '../../../theme';

const InfoText = ({ textInfo, withHTML, withoutBackground, background }) => {
  const classes = useStyles();

  if (!textInfo) {
    return null;
  }

  return (
    <Grid
      container
      className={classes.root}
      style={{
        background: withoutBackground ? 'transparent' : background,
      }}
      spacing={2}
    >
      <Grid item className={classes.infoIcon}>
        <InfoIcon />
      </Grid>
      <Grid item>
        {withHTML ? (
          <Typography component="div" className={classes.text}>
            <p
              dangerouslySetInnerHTML={{
                __html: textInfo,
              }}
            />
          </Typography>
        ) : (
          <Typography>{textInfo}</Typography>
        )}
      </Grid>
    </Grid>
  );
};

InfoText.propTypes = {
  textInfo: PropTypes.string.isRequired,
  withHTML: PropTypes.bool,
  withoutBackground: PropTypes.bool,
  background: PropTypes.string,
};

InfoText.defaultProps = {
  withHTML: false,
  withoutBackground: false,
  background: aliceGray,
};

export default InfoText;
